<!-- @format -->

<!--<mat-toolbar style="display: flex">
  <span>Spaces</span>

  <div class="flex-auto"></div>
</mat-toolbar>-->
<div class="space-y-2 mb-2 md:mb-4">
  <div class="flex items-center">
    <div class="text-2xl font-bold spacer">
      {{ _common.findSpace.search_result }}
    </div>
    <div
      [routerLink]="[session.path('/space-search')]"
      class="text-link link-blue"
    >
      {{ _common.findSpace.search_again }}
    </div>
  </div>
  <div class="flex space-x-2">
    <fa-icon icon="filter" *ngIf="type || area || capacityMin"></fa-icon>
    <div *ngFor="let t of type">{{ lang(t?.name, t?.name_lang) }}</div>
    <div *ngIf="area">
      {{ _common[area] }}
      <ng-container *ngIf="district"> - {{ _common[district] }}</ng-container>
    </div>
    <div *ngIf="capacityMin || capacityMax">
      <ng-container *ngIf="capacityMin && capacityMax">
        {{ capacityMin }}-{{ capacityMax }}{{ _common.People }}
      </ng-container>
      <ng-container *ngIf="capacityMin && !capacityMax">
        {{ _common.findSpace.ppl_above_en }} {{ capacityMin }}{{ _common.People
        }}{{ _common.findSpace.ppl_above_zh }}
      </ng-container>
    </div>
  </div>

  <div class="flex space-x-2">
    <!-- <div class="search_bar spacer">
      <fa-icon matPrefix icon="search" class="searchIcon"></fa-icon>
      <input
        class="w-full"
        matInput
        [(ngModel)]="filter"
        (keyup)="applyFilter($event.target)"
        placeholder="{{ _common.search }}"
        #_search
      />
      <fa-icon
        icon="times"
        matSuffix
        (click)="clearFilter(_search)"
        class="clearSearch"
      ></fa-icon>
    </div> -->
    <div class="flex-auto max-w-[300px]">
      <app-form-field class="w-full">
        <input
          matInput
          [matDatepicker]="picker"
          [(ngModel)]="date"
          (dateChange)="refresh()"
        />
        <mat-datepicker-toggle
          appIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </app-form-field>
    </div>
    <div>
      <app-form-field>
        <mat-select [(ngModel)]="hour" (selectionChange)="refresh()">
          <mat-option [value]="allHours">{{
            _common.findSpace.any_time
          }}</mat-option>
          <mat-option *ngFor="let h of hours" [value]="h.hour">
            {{ h.text }}
          </mat-option>
        </mat-select>
      </app-form-field>
    </div>
  </div>
</div>

<div *ngIf="!objects.data.length" class="text-center" style="margin-top: 10%">
  <div class="flex justify-center">
    <img src="/silone/silone_notfound.png" style="height: 100px" />
  </div>

  <div class="mt-4">{{ _common.no_result }}</div>
</div>
<app-scroll-container
  [more]="hasMore()"
  (scrolled)="handleScroll($event)"
  #scroll
>
  <div class="item_list">
    <div *ngFor="let o of objects.data">
      <app-space-card [space]="o"></app-space-card>
    </div>
  </div>
</app-scroll-container>
